module.exports = __webpack_public_path__ + "static/media/box-fragile.d495f1fc.svg";